import { render, staticRenderFns } from "./ButtonTemplateItemEditor.vue?vue&type=template&id=478c23a4"
import script from "./ButtonTemplateItemEditor.vue?vue&type=script&lang=js"
export * from "./ButtonTemplateItemEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports